module.exports = __webpack_public_path__ + "static/media/stackoverflow.eb6c77c8.svg";